import {Ability} from '~/lib/ability';
import {IPreTargetingConfig} from '~/modules/Bidders/models/PreTargeting';

export class BiddersAbility extends Ability {
    canEdit = () => this.isAdmin();
    canCopy = () => this.isAdmin();
    canCreate = () => this.isAdmin();
    canDelete = () => this.isAdmin();
    canViewPreTargeting = () => this.isAdmin() || this.isManager();
}

export class PreTargetingAbility extends Ability {
    canEdit = (preTargeting: IPreTargetingConfig) => this.isAdmin();
    canCreate = () => this.isAdmin();
    canDelete = (preTargeting: IPreTargetingConfig) => this.isAdmin();
}

